import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRotateRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36.7143 14.8571C37.4214 14.8571 38 14.2786 38 13.5714V3.28571C38 2.57857 37.4214 2 36.7143 2C36.0071 2 35.4286 2.57857 35.4286 3.28571V10.7268C32.2786 5.49554 26.5491 2 20 2C10.0598 2 2 10.0598 2 20C2 29.9402 10.0598 38 20 38C26.4205 38 32.0536 34.6411 35.2437 29.5786C35.7661 28.7429 35.1312 27.7143 34.1429 27.7143C33.6607 27.7143 33.2268 27.9714 32.9616 28.3732C30.2134 32.6161 25.4321 35.4286 20 35.4286C11.4821 35.4286 4.57143 28.5179 4.57143 20C4.57143 11.4821 11.4821 4.57143 20 4.57143C25.7134 4.57143 30.6955 7.67321 33.3634 12.2857H26.4286C25.7214 12.2857 25.1429 12.8643 25.1429 13.5714C25.1429 14.2786 25.7214 14.8571 26.4286 14.8571H36.7143Z" })
});
export default SvgArrowRotateRight;
